export const transferGasLimit = {
    NATIVE_TRANSFER_GAS_LIMIT: 130_000,
    TOKEN_TRANSFER_GAS_LIMIT: 150_000
};
